export default __webpack_public_path__ + "static/media/minigame-2.1f2994e3.gif";